import { Box, Button, Center, Flex, Image, Text } from '@chakra-ui/react';
import { filesize } from 'filesize';
import { Color } from 'presentation/theme/colorScheme';
import { FontSize } from 'presentation/theme/fontSizes';
import downloadFile from 'presentation/utils/downloadFile';
import { FC, useRef, useState } from 'react';
import { MdFilePresent } from 'react-icons/md';
import ChatMessageImageViewer from './ChatMessageImageViewer';

interface Props extends ChatMessageFile {}

const ChatMessageFile: FC<Props> = ({ name, size, url }) => {
  const [failedPreviewUrl, setFailedPreviewUrl] = useState<string | null>(null);
  const [isViewerOpen, setIsViewerOpen] = useState(false);
  const previewRef = useRef<HTMLButtonElement>(null);
  const isImage = /\.(jpe?g|png|webp)$/i.test(name);

  if (isImage && failedPreviewUrl !== url) {
    return (
      <Box py={1}>
        <Button
          ref={previewRef}
          variant="unstyled"
          p={0}
          display="block"
          w="280px"
          maxW="100%"
          h="200px"
          overflow="hidden"
          borderRadius="8px"
          onClick={() => setIsViewerOpen(true)}
        >
          <Image
            ignoreFallback
            src={url}
            alt={name}
            w="100%"
            h="100%"
            objectFit="contain"
            onError={() => setFailedPreviewUrl(url)}
          />
        </Button>
        {isViewerOpen && (
          <ChatMessageImageViewer
            name={name}
            url={url}
            onClose={() => setIsViewerOpen(false)}
            finalFocusRef={previewRef}
          />
        )}
      </Box>
    );
  }

  return (
    <Flex
      py={1}
      cursor="pointer"
      onClick={() => {
        downloadFile(url);
      }}
      alignItems="center"
    >
      <Center
        mr={4}
        bgColor={Color.OnPrimary}
        width={10}
        height={10}
        borderRadius="50%"
      >
        <MdFilePresent />
      </Center>
      <Box flex="1" minW={0}>
        <Text
          mb="2px"
          maxW="200px"
          overflowWrap="anywhere"
          wordBreak="break-word"
        >
          {name}
        </Text>
        <Text fontSize={FontSize.xs}>
          {filesize(size, { base: 2 }) as string}
        </Text>
      </Box>
    </Flex>
  );
};

export default ChatMessageFile;
